import { Card, CardContent, CardHeader } from '@mui/material';
import { Grid } from '@mui/system';
import { isUndefined } from 'lodash';
import { useSelector } from 'react-redux';
import { useFormat } from 'common/hooks';
import { LoadingSection } from 'components';
import { REGULAR_UNIT } from 'components/FeaturedSpreadsheet/constants';
import { WaterfallCalculator } from 'dashboard409a/components';
import { IWaterfallState } from 'dashboard409a/states/features/waterfall';
import { RootStateType } from 'dashboard409a/states/store';
import { SubscriptionExpiredBox } from '../SubscriptionExpiredBox';
import { BreakpointChart } from './components/BreakpointAnalysisChart';
import { IWaterfallCalculatorProps } from '../WaterfallCalculator/types';
import { BreakpointChartProps } from './components/BreakpointAnalysisChart/types';

const Waterfall = () => {
  const { loading, waterfallBreakpoint, currentCaptable } = useSelector<RootStateType, IWaterfallState>(
    state => state.waterfall
  );
  const { currentCompany } = useSelector((state: RootStateType) => state.global);
  const subscriptionIsActive = currentCompany?.is_active;
  const displayExpired = !isUndefined(subscriptionIsActive) && subscriptionIsActive === false;
  const [format, formatDispatch] = useFormat({ units: REGULAR_UNIT });

  const waterfallCalculatorProps: IWaterfallCalculatorProps = {
    isLoading: loading,
    data: currentCaptable,
    format,
    formatDispatch,
  };

  const breakpointChartProps: BreakpointChartProps = {
    isLoading: loading,
    data: waterfallBreakpoint,
  };

  if (displayExpired) {
    return (
      <Grid spacing={2} justifyContent="center">
        <Card>
          <SubscriptionExpiredBox />
        </Card>
      </Grid>
    );
  }

  return loading || !waterfallBreakpoint ? (
    <LoadingSection />
  ) : (
    <Grid container spacing={2} justifyContent="flex-start">
      <Grid size={{ lg: 6, xs: 12 }}>
        <Card sx={{ boxShadow: 'none' }}>
          <CardContent>
            <WaterfallCalculator {...waterfallCalculatorProps} />
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{ lg: 6, xs: 12 }}>
        {/* Soft-bordered panel with the faded in-panel title (redesign). */}
        <Card sx={{ border: '1px solid #EAECF0', borderRadius: 2, boxShadow: 'none' }}>
          <CardHeader
            title="Breakpoint Analysis"
            titleTypographyProps={{ sx: { color: '#AEB6C2', fontSize: '1rem', fontWeight: 600 } }}
          />
          <CardContent>
            <BreakpointChart {...breakpointChartProps} />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Waterfall;
